import { render, staticRenderFns } from "./ToeflITPLevel2ScoreComponent.vue?vue&type=template&id=0da382d9&scoped=true&"
import script from "./ToeflITPLevel2ScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflITPLevel2ScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflITPLevel2ScoreComponent.vue?vue&type=style&index=0&id=0da382d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da382d9",
  null
  
)

export default component.exports